<template>
  <v-card>
    <v-card-title primary-title>
      <h3 class="text-uppercase">Assessment</h3>
      <v-switch
        v-model="isPM"
        :label="`${isPM ? 'PM' : 'PLM'}`"
        color="success"
        class="ma-0 pa-0 ml-3"
        hide-details
      ></v-switch>
    </v-card-title>
    <v-card-text>
      <v-container fluid class="pa-0">
        <v-layout wrap align-top>
          <template v-for="(status, idx) in fields">
            <v-flex :key="idx" v-if="isNotEmptyValue(status)" xs3>
              <h4 class="pt-2 pb-2">{{ status.title.replace(/\_/g, ' ') }}:</h4>
            </v-flex>
            <template v-for="(value, key) in status">
              <template v-if="key !== 'title'">
                <template v-if="isRating(value)">
                  <v-flex class="text-xs-right" :key="key" xs9>
                    <v-rating
                      :value="value"
                      background-color="green"
                      color="green"
                      readonly
                    />
                  </v-flex>
                </template>
                <template v-else>
                  <v-flex class="mb-3" v-if="value.length" :key="key" xs12>
                    <div class="grey lighten-4 pa-1 font-weight-light" v-text="value"></div>
                  </v-flex>
                </template>
              </template>
            </template>
            <v-flex :key="`divider_${idx}`" v-if="idx !== fields.length - 1" xs12>
              <v-divider/>
            </v-flex>
          </template>
          <template v-if="showBtn">
            <v-flex class="text-xs-right mt-3" xs12>
              <v-btn
                @click="showEditPopup"
                color="warning"
              >
                ASSESSMENT
              </v-btn>
            </v-flex>
          </template>
        </v-layout>
      </v-container>
    </v-card-text>
    <popup
      :status.sync="editPopupStatus"
      :fields="fields"
      :id="id"
    />
  </v-card>
</template>
<script>
export default {
  name: 'assessment',
  props: {
    id: [String, Number],
    assessmentFields: {
      type: Object,
      default: () => ({}),
    },
    showEditBtn: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      editPopupStatus: false,
      isPM: true,
    };
  },
  computed: {
    showBtn() {
      const currentShowSlug = this.isPM ? 'PM' : 'PLM';
      return this.showEditBtn && (currentShowSlug === this.currentGroup.slug);
    },
    fields() {
      const currentFields = this.assessmentFields[`assessment_${ this.isPM ? 'pm' : 'plm' }`];
      return Object
        .keys(currentFields)
        .sort()
        .reduce((acc, key, i, ar) => {
          if (key === 'PRESENT' || acc.find(o => key in o || k2k in o)) return acc;

          let obj = {
            title: key,
            [key]: currentFields[key],
          };

          const k2k = ar.find(k => k.includes(key) && k !== key && key.includes('_'));

          if (k2k) {
            obj = Object.assign(obj, { [k2k]: currentFields[`${ k2k }`] });
            acc.unshift(obj);
          } else {
            acc.push(obj);
          }

          return acc;
        }, []);
    },
  },
  methods: {
    isRating(val) {
      return typeof val === 'number';
    },
    isNotEmptyValue(obj) {
      return Object.entries(obj)
        .find(([key, value]) => {
          return this.isRating(value) || (key !== 'title' && value.length);
        });
    },
    showEditPopup() {
      this.editPopupStatus = true;
    },
  },
  components: {
    popup: () => import('@/components/assessment/popup'),
  },
};
</script>
